// @flow
import React, { Fragment } from 'react';

import { AbTasty } from './AbTasty';
import { ContentSquare } from './ContentSquare';
import { Freespee } from './Freespee';
import { Hosting } from './Hosting';
import { Jivochat } from './Jivochat';

export const ThirdPartyScripts = () => (
  <Fragment>
    <Jivochat />
    <ContentSquare />
    <Hosting />
    <AbTasty />
    <Freespee />
  </Fragment>
);
